import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ApiError from '@/lib/shared-coms/ApiError';
import PlaceholderReceiving from './PlaceholderReceiving';
import { useRootStore } from '@/lib/providers/RootProvider';

const PURCHASE_ORDER = gql`
  query purchaseOrder($id: ID!, $clientId: ID!) {
    purchaseOrder(id: $id, clientId: $clientId) {
      id
      clientPurchaseOrderNumber
      orderItems {
        id
        productId
        quantity
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
        }
      }
      vendor {
        id
        companyName
      }
    }
  }
`;

const RECEIVE_PLACEHOLDER_INVENTORY = gql`
  mutation receivePlaceholderInventory(
    $id: ID!
    $orderItems: [OrderItemAttributes!]!
    $companyId: ID!
  ) {
    receivePlaceholderInventory(id: $id, orderItems: $orderItems, companyId: $companyId) {
      id
      clientStatus
    }
  }
`;

function PlaceholderReceivingData(props) {
  const clientId = useRootStore((state) => state.selectedCompany.id);
  const [receivePlaceholderInventory] = useMutation(RECEIVE_PLACEHOLDER_INVENTORY);
  const { purchaseOrderId } = useParams();
  const { data, error, loading, refetch } = useQuery(PURCHASE_ORDER, {
    variables: { id: purchaseOrderId, clientId },
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { purchaseOrder } = data || {};
  if (!purchaseOrder) return <ApiError error={new Error('Order not found') as any} />;

  return (
    <PlaceholderReceiving
      purchaseOrder={purchaseOrder}
      receivePlaceholderInventory={receivePlaceholderInventory}
      refetch={refetch}
      {...props}
    />
  );
}

export default PlaceholderReceivingData;
